import { InfoCardRs, InfoContentType } from '@domain/rs/info/InfoCardListRs';
import { InfoDetailRs } from '@domain/rs/info/InfoDetailRs';
import { InfoCategoryType } from '@domain/rs/info/InfoCategoryListRs';
import { getFileImg } from '@utils/common';

export class InfoDetailVO {
  sn: number;
  categoryIconType: InfoCategoryType;
  categoryName: string;
  categorySn: number;
  chatManagerName: string; //채팅 관리자 닉네임
  chatYn: boolean; // 채팅창 오픈 여부
  chatUrl: string; //채팅 Url
  logoUid: string; //채팅 로고 uid
  type: InfoContentType;
  title: string;
  views: number;
  label: string;
  contents: string;
  thumbnailUrl: string;
  link: string | null;
  createdDateTime: string;
  postCards: InfoCardRs[];

  constructor(rs: InfoDetailRs) {
    this.sn = rs.sn;
    this.categoryIconType = rs.categoryIconType;
    this.categoryName = rs.categoryName;
    this.categorySn = rs.categorySn;
    this.chatManagerName = rs.chatManagerName;
    this.chatYn = rs.chatYn;
    this.chatUrl = rs.chatUrl;
    this.logoUid = rs.logoUid ? getFileImg(rs.logoUid) : '';
    this.type = rs.type;
    this.title = rs.title;
    this.views = rs.views;
    this.label = rs.label;
    this.contents = rs.contents;
    this.thumbnailUrl = rs.thumbnailUid ? getFileImg(rs.thumbnailUid) : '/img/info/list/imgDefaultThumbnail.png';
    this.link = rs.link;
    this.createdDateTime = rs.createdDateTime;
    this.postCards = rs.postCards;
  }
}
